import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import TrackContainer from "./TrackContainer";
import { selectRole } from "./infoSlice";
import { selectEventsData, setEventData } from "../events/eventsSlice";
import { sendAnalyticsEvents } from "../../analytics/common";
import { EVENTS } from "../../analytics/events";

const LocationTypeTrack = ({ history }) => {
  const { t } = useTranslation();
  const role = useSelector(selectRole);
  const dispatch = useDispatch();
  const eventsData = useSelector(selectEventsData);
  const locationTypeOptions = useMemo(() => {
    let options = [];
    switch (role) {
      case "Partner":
        options = [
          {
            id: 0,
            imgPath: ('../assets/types_of_locations/bars_casinos.png'),
            name: t("bars_casinos"),
            value: "Bars"
          },
          {
            id: 1,
            imgPath: ('../assets/types_of_locations/nightclubs.png'),
            name: t("nightclubs"),
            value: "Nightclubs"
          },
          {
            id: 2,
            imgPath: ('../assets/types_of_locations/hotels.png'),
            name: t("hotels"),
            value: "Hotels"
          },
          {
            id: 3,
            imgPath: ('../assets/types_of_locations/unknown_locations.png'),
            name: t("unknown_locations"),
            value: "Unknown"
          },
          {
            id: 4,
            imgPath: ('../assets/types_of_locations/ex_house.png'),
            name: t("ex_house"),
            value: "Ex"
          },
        ];
        break;
      case "Kid":
        options = [
          {
            id: 0,
            imgPath: ('../assets/types_of_locations/unknown_locations.png'),
            name: t("unknown_locations"),
            value: "Unknown"
          },
          {
            id: 1,
            imgPath: ('../assets/types_of_locations/friends_homes.png'),
            name: t("friends_homes"),
            value: "Friends"
          },
          {
            id: 2,
            imgPath: ('../assets/types_of_locations/shopping_malls.png'),
            name: t("shopping_malls"),
            value: "ShoppingMalls"
          },
          {
            id: 3,
            imgPath: ('../assets/types_of_locations/unsafe_parks_playgrounds.png'),
            name: t("unsafe_parks"),
            value: "UnsafePlaces"
          },
          {
            id: 4,
            imgPath: ('../assets/types_of_locations/unsupervised_public_areas.png'),
            name: t("unsupervised_areas"),
            value: "PublicAreas"
          },
        ];
        break;
      case "Friend":
        options = [
          {
            id: 0,
            imgPath: ('../assets/types_of_locations/areas_high_crime.png'),
            name: t("areas_with_crime"),
            value: "CrimeAreas"
          },
          {
            id: 1,
            imgPath: ('../assets/types_of_locations/unknown_locations.png'),
            name: t("unknown_locations"),
            value: "Unknown"
          },
          {
            id: 2,
            imgPath: ('../assets/types_of_locations/unsafe_parks_playgrounds.png'),
            name: t("unsafe_parks"),
            value: "UnsafePlaces"
          },
        ];
        break;
      case "Sibling":
        options = [
          {
            id: 0,
            imgPath: ('../assets/types_of_locations/areas_high_crime.png'),
            name: t("areas_with_crime"),
            value: "CrimeAreas"
          },
          {
            id: 1,
            imgPath: ('../assets/types_of_locations/easily_lost_locations.png'),
            name: t("easily_lost"),
            value: "EasilyLost"
          },
          {
            id: 2,
            imgPath: ('../assets/types_of_locations/unknown_locations.png'),
            name: t("unknown_locations"),
            value: "Unknown"
          },
        ];
        break;
      case "Grandparent":
        options = [
          {
            id: 0,
            imgPath: ('../assets/types_of_locations/distant_place_from_home.png'),
            name: t("distant_places"),
            value: "DistantPlaces"
          },
          {
            id: 1,
            imgPath: ('../assets/types_of_locations/high_risk_injury.png'),
            name: t("high_risk_injury"),
            value: "InjuryPlaces"
          },
          {
            id: 2,
            imgPath: ('../assets/types_of_locations/easily_lost_locations.png'),
            name: t("easily_lost"),
            value: "EasilyLost"
          },
          {
            id: 3,
            imgPath: ('../assets/types_of_locations/unknown_locations.png'),
            name: t("unknown_locations"),
            value: "Unknown"
          },
        ];
        break;
      default:
        options = [
          {
            id: 0,
            imgPath: ('../assets/types_of_locations/areas_high_crime.png'),
            name: t("areas_with_crime"),
            value: "CrimeAreas"
          },
          {
            id: 1,
            imgPath: ('../assets/types_of_locations/easily_lost_locations.png'),
            name: t("easily_lost"),
            value: "EasilyLost"
          },
          {
            id: 2,
            imgPath: ('../assets/types_of_locations/unknown_locations.png'),
            name: t("unknown_locations"),
            value: "Unknown"
          },
        ];
        break;
    }

    const lastOption = {
      id: options.length + 1,
      imgPath: ('../assets/types_of_locations/other.png'),
      name: t("other"),
      value: "Other"
    };
    options.push(lastOption);

    return options;
  }, [t, role]);

  const onContinueClick = (locationTypes) => {
    dispatch(setEventData({ id: "InappropriateGeos", data: locationTypes }));
    sendAnalyticsEvents(EVENTS.onboardingInappropriateSubmitted, {
      ...eventsData,
      InappropriateGeos: locationTypes,
    });
    history.push("/choose-quantity");
  };

  return (
    <TrackContainer
      pageEvent={"onboardingInappropriateShown"}
      title={
        role === "Other"
          ? t("question6_other")
          : t("question6_title", { role: role.toLowerCase() })
      }
      multiple
      options={locationTypeOptions}
      onContinueClick={onContinueClick}
      nextPage={'choose-quantity'}
    />
  );
};

export default LocationTypeTrack;
